import React from "react";
import { Document, Page, Text, View, StyleSheet, Image  } from "@react-pdf/renderer";
import SafeImage from "./safeimage";
import dayjs from "dayjs";
import logo from './BrainyCare-Logo.jpg'
import logowithtext from'./chimwithlogo.png'
import { practiceFeatures, practiceName, practiceLogo, logoShowsName, practiceContact, intakeBrand, codeIntake } from "../config/practice";
import { intakeConsents } from "./intakeConsents";
// PDF Styles matching the template
const styles = StyleSheet.create({
page: { 
  paddingTop: 30,
  paddingLeft: 30,
  paddingRight: 30,
  paddingBottom: 70, // reserve space for footer
  fontSize: 9,
  fontFamily: "Helvetica",
  backgroundColor: "#ffffff"
},
  
  // Header styles
  documentHeader: {
    textAlign: "center",
    marginBottom: 20,
    borderBottom: "2pt solid #000000",
    paddingBottom: 15
  },
  clinicName: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 5,
    textTransform: "uppercase",
    letterSpacing: 0.5
  },
  clinicInfo: {
    fontSize: 8,
    color: "#333333",
    marginBottom: 2
  },
  formTitle: {
    fontSize: 10,
    marginTop: 5,
    textTransform: "uppercase",
    letterSpacing: 0.3
  },
  
  // Section styles
  section: { 
    marginBottom: 15,
    // borderBottom: "1pt solid #000000",
    paddingBottom: 10
  },
  divider: {
  borderBottom: "1.5pt solid #000",
  // paddingBottom: 7,
  marginBottom: 10
},
  sectionHeader: { 
    fontSize: 11, 
   // fontWeight: "bold",
    marginBottom: 2,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    backgroundColor: "#ffffff",
    paddingBottom: 1
  },
  
  // Grid layout for patient details
  detailsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 8
  },
  detailColumn: {
    width: "33.33%",
    marginBottom: 6
  },
  detailColumnWide: {
    width: "66.66%",
    marginBottom: 6
  },
  detailColumnFull: {
    width: "100%",
    marginBottom: 6
  },
  
  fieldLabel: {
    fontSize: 10,
    color: "#4A5565",
    textTransform: "uppercase",
      fontFamily: "Helvetica",
    marginBottom: 2,
    fontWeight: 400,
    letterSpacing: 0.3
  },
  fieldValue: {
    fontSize: 10,
    color: "#0A0A0A",
    fontWeight: "normal",
     fontFamily: "Helvetica",
       fontWeight: 400,

  },
  
  // Table styles
  table: { 
    width: "100%",
    marginTop: 8,
    marginBottom: 8
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "0.5pt solid #cccccc",
    paddingBottom: 4,
         fontFamily: "Helvetica",
    marginBottom: 4
  },
tableHeaderCell: {
  fontSize: 8,
  fontFamily: "Helvetica-Bold",
  color: "#4A5565",
  textTransform: "uppercase",
  letterSpacing: 0.3
},
  tableRow: { 
    flexDirection: "row",
    paddingVertical: 3,
    borderBottom: "0.5pt solid #cccccc"
  },
  tableCell: {
    fontSize: 9,
    color:'#0A0A0A',
    paddingRight: 5
  },
headerWrapper: {
  width: "100%",
  borderBottom: "1.5pt solid #000",
  paddingBottom: 12,
  marginBottom: 18
},

headerContainer: {
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "center"
},
logoTitleRow: {
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 6
},
logo: {
  width: 48,
  height: 48,
  marginRight: 12,

},

headerTextContainer: {
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
},

clinicName: {
  fontSize: 16,
  fontFamily: "Helvetica-Bold",
  letterSpacing: 2,
  lineHeight: 1.2

  // textAlign: "center"
},headerInfo: {
  marginLeft: 50,   // pushes text to start from clinic title
},

logoImageRow: {
  alignItems: "center",
  marginBottom: 6
},

logoWithText: {
  width: 300,
  height: 60,
  objectFit: "contain"
},

// CODE's text letterhead (a dept-3 intake row; CODE has no logo art yet, D10)
codeMark: {
  fontSize: 22,
  fontFamily: "Helvetica-Bold",
  color: "#0b6b6b",
  letterSpacing: 2,
  textAlign: "center"
},
codeName: {
  fontSize: 11,
  fontFamily: "Helvetica-Bold",
  color: "#0b6b6b",
  textAlign: "center",
  marginTop: 2
},

headerInfo: {
  alignItems: "center"
},
doctorNames: {
  fontSize: 10,
  fontFamily: "Helvetica-Bold",
  marginBottom: 2,
  textAlign: "center"
},

address: {
  fontSize: 9,
  marginBottom: 2,
  textAlign: "center"
},

contact: {
  fontSize: 9,
    textAlign: "center"
},
  // Column widths for different tables
  col1: { width: "33.33%" },
  col2: { width: "33.33%" },
  col3: { width: "33.33%" },
  colMed: { width: "40%" },
  colDose: { width: "20%" },
  colTimes: { width: "20%" },
  colAgent: { width: "50%" },
  colReaction: { width: "50%" },
  
  // List styles
  listItem: {
    fontSize: 9,
    marginLeft: 15,
    marginBottom: 3,
    flexDirection: "row"
  },
  bullet: {
    width: 15,
    marginRight: 5
  },
  
  // Consent checkbox styles
  consentItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 8
  },
checkbox: {
  width: 12,
  height: 12,
  border: "1pt solid #000",
  marginRight: 8,
  marginTop: 2,
  position: "relative"
},

checkmark: {
  position: "absolute",
  left: 2,
  top: -1,
  width: 5,
  height: 9,
  borderRight: "2pt solid #16a34a",
  borderBottom: "2pt solid #16a34a",
  transform: "rotate(45deg)"
},
  consentText: {
    flex: 1,
    fontSize: 9,
    lineHeight: 1.4
  },
  
  // Image styles
  image: {
    width: 120,
    height: 120,
    marginVertical: 8,
    marginHorizontal: "auto"
  },
  
  // Subsection
  subsectionTitle: {
    fontSize: 10,
    color: "#4A5565",
    textTransform: "uppercase",
      fontFamily: "Helvetica",
    marginBottom: 6,
    fontWeight: 400,
    letterSpacing: 0.3
  },
  
  footer: {
  position: "absolute",
  bottom: 25,
  left: 30,
  right: 30,
  textAlign: "center",
  fontSize: 7,
  color: "#666666",
  borderTop: "0.5pt solid #cccccc",
  paddingTop: 8
},
  receiptContainer: {
  marginTop: 10,
},

receiptDate: {
  marginTop: 10,
  marginBottom: 20,
},

signatureRow: {
  flexDirection: "row",
  justifyContent: "space-between",
  marginTop: 40,
},

signatureBox: {
  width: "70%",
},

dateBox: {
  width: "25%",
},

line: {
  borderBottom: "1pt solid #000000",
  height: 10,
  marginTop: 4
},
signatureLine: {
  borderBottom: "1pt solid #000000",
  height: 20,
  marginBottom: 6
},

signatureLabel: {
  fontSize: 8,
  color: "#666666",
  textTransform: "uppercase",
  letterSpacing: 0.5
},

bulletText: {
  fontSize: 22,
  color: '#065f46',
  marginRight: 8,
  marginTop: -5,
},
questionItem: {
  flexDirection: 'row',
  alignItems: 'flex-start',

},
questionText: {
  flex: 1,
  fontSize: 14,
  color: '#111',
}

});

const OnboardPDF = ({ data, forms }) => {
  // The intake row's location: a CODE (dept 3) intake gets CODE's letterhead,
  // name and contact lines (same legal entity as C-HIM, owner 2026-10-18);
  // every other 9928 intake C-HIM's, exactly as before (config/practice.js
  // intakeBrand).
  const brand = intakeBrand(data?.departmentid);
  const codeLetterhead = practiceFeatures().chimContact && brand.id === codeIntake.id;
  const renderAge = (dob) => {
    if (!dob) return "-";
    const birthDate = new Date(dob);
    const ageDifMs = Date.now() - birthDate.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const prettifyKey = (key) =>
    key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

  const formatDate = (date) => {
    if (!date || date === "Invalid date") return "-";
    return date;
  };

  const tertiaryDOB = formatDate(forms.form_2?.tertiarydob);
  const secondaryDOB = formatDate(forms.form_2?.secondarydob);
  const primaryDOB = formatDate(forms.form_2?.primarydob);

  const normalizedForm3 = {
    ...(forms.form_3 || {}),
    healthConcerns: forms.form_3?.healthConcerns || forms.form_3?.healthconcerns || [],
    gynecologicHistory: forms.form_3?.gynecologicHistory || null,
  };



    const QUESTIONNAIRES = {
      phq9: {
        title: 'PHQ-9 Depression Screener',
        subtitle: 'Patient Health Questionnaire',
        instructions: 'Over the last 2 weeks, how often have you been bothered by any of the following problems?',
        questions: [
          'Little interest or pleasure in doing things',
          'Feeling down, depressed, or hopeless',
          'Trouble falling or staying asleep, or sleeping too much',
          'Feeling tired or having little energy',
          'Poor appetite or overeating',
          'Feeling bad about yourself — or that you are a failure or have let yourself or your family down',
          'Trouble concentrating on things, such as reading the newspaper or watching television',
          'Moving or speaking so slowly that other people could have noticed? Or the opposite — being so fidgety or restless that you have been moving around a lot more than usual',
          'Thoughts that you would be better off dead or of hurting yourself in some way'
        ],
        options: [
          { label: 'Not at all', value: 0 },
          { label: 'Several days', value: 1 },
          { label: 'More than half the days', value: 2 },
          { label: 'Nearly every day', value: 3 }
        ],
        extraQuestion: {
          id: 'phq9_extra',
          text: 'If you checked off any problems, how difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?',
          options: [
            { label: 'Not difficult at all', value: 0 },
            { label: 'Somewhat difficult', value: 1 },
            { label: 'Very difficult', value: 2 },
            { label: 'Extremely difficult', value: 3 }
          ]
        },
        score(answers) {
          const total = answers.slice(0, 9).reduce((s, v) => s + (v || 0), 0);
          let level, color, bg;
          if (total <= 4)       { level = 'None – Minimal Depression';     color = '#065f46'; bg = '#ecfdf5'; }
          else if (total <= 9)  { level = 'Mild Depression';               color = '#92400e'; bg = '#fef3c7'; }
          else if (total <= 14) { level = 'Moderate Depression';           color = '#92400e'; bg = '#fef3c7'; }
          else if (total <= 19) { level = 'Moderately Severe Depression';  color = '#991b1b'; bg = '#fee2e2'; }
          else                  { level = 'Severe Depression';             color = '#991b1b'; bg = '#fee2e2'; }
          return { total, level, color, bg,
            text: `Your PHQ-9 score is ${total}/27. Result: ${level}. Your provider will review these results at your appointment.` };
        }
      },

      stopbang: {
        title: 'STOP-BANG Sleep Apnea Screener',
        subtitle: 'Obstructive Sleep Apnea Risk Assessment',
        instructions: 'Please answer Yes or No to each of the following questions.',
        questions: [
          'Snoring — Do you snore loudly (louder than talking or loud enough to be heard through closed doors)?',
          'Tired — Do you often feel tired, fatigued, or sleepy during the daytime?',
          'Observed — Has anyone observed you stop breathing or choking/gasping during your sleep?',
          'Pressure — Do you have or are you being treated for high blood pressure?',
          'BMI — Is your BMI greater than 35?',
          'Age — Are you older than 50 years?',
          'Neck — Is your neck circumference greater than 40 cm (15.7 inches)?',
          'Gender — Are you male?'
        ],
        options: [
          { label: 'Yes', value: 1 },
          { label: 'No',  value: 0 }
        ],
        score(answers) {
          const total = answers.reduce((s, v) => s + (v || 0), 0);
          let level, color, bg;
          if (total <= 2)      { level = 'Low Risk for OSA';          color = '#065f46'; bg = '#ecfdf5'; }
          else if (total <= 4) { level = 'Intermediate Risk for OSA'; color = '#92400e'; bg = '#fef3c7'; }
          else                 { level = 'High Risk for OSA';         color = '#991b1b'; bg = '#fee2e2'; }
          return { total, level, color, bg,
            text: `Your STOP-BANG score is ${total}/8. Result: ${level}. Your provider will review these results at your appointment.` };
        }
      },

      adhd: {
        title: 'ASRS-v1.1 Adult ADHD Self-Report Scale',
        subtitle: 'World Health Organization Screener — Part A',
        instructions: 'Please answer the questions below, rating yourself on each of the criteria shown, using the scale on the right side of the page. As you answer each question, place an X in the box that best describes how you have felt and conducted yourself over the past 6 months.',
        questions: [
          'How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?',
          'How often do you have difficulty getting things in order when you have to do a task that requires organization?',
          'How often do you have problems remembering appointments or obligations?',
          'When you have a task that requires a lot of thought, how often do you avoid or delay getting started?',
          'How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?',
          'How often do you feel overly active and compelled to do things, like you were driven by a motor?'
        ],
        options: [
          { label: 'Never',     value: 0 },
          { label: 'Rarely',    value: 1 },
          { label: 'Sometimes', value: 2 },
          { label: 'Often',     value: 3 },
          { label: 'Very Often',value: 4 }
        ],
        // ASRS Part A: positives = Sometimes/Often/VeryOften for Q1–3, Often/VeryOften for Q4–6
        score(answers) {
          const thresholds = [2, 2, 2, 3, 3, 3]; // "Sometimes" triggers Q1-3, "Often" triggers Q4-6
          let positives = 0;
          answers.forEach((v, i) => { if ((v || 0) >= thresholds[i]) positives++; });
          const likely = positives >= 4;
          const level = likely ? 'Symptoms Consistent with ADHD' : 'Symptoms Unlikely to Indicate ADHD';
          const color = likely ? '#991b1b' : '#065f46';
          const bg    = likely ? '#fee2e2' : '#ecfdf5';
          return { total: positives, level, color, bg,
            text: `${positives} of 6 responses fell in the shaded zone. Result: ${level}. This is a screener only — your provider will discuss next steps at your appointment.` };
        }
      },

      mdq: {
        title: 'MDQ — Mood Disorder Questionnaire',
        subtitle: 'Bipolar Spectrum Screening Tool',
        instructions: 'Has there ever been a period of time when you were not your usual self and… (check all that apply)',
        questions: [
          '…you felt so good or so hyper that other people thought you were not your normal self or you were so hyper that you got into trouble?',
          '…you were so irritable that you shouted at people or started fights or arguments?',
          '…you felt much more self-confident than usual?',
          '…you got much less sleep than usual and found you didn\'t really miss it?',
          '…you were much more talkative or spoke much faster than usual?',
          '…thoughts raced through your head or you couldn\'t slow your mind down?',
          '…you were so easily distracted by things around you that you had trouble concentrating or staying on track?',
          '…you had much more energy than usual?',
          '…you were much more active or did many more things than usual?',
          '…you were much more social or outgoing than usual (e.g., telephoned friends in the middle of the night)?',
          '…you were much more interested in sex than usual?',
          '…you did things that were unusual for you or that other people might have seen as excessive, foolish, or risky?',
          '…spending money got you or your family into trouble?'
        ],
        options: [
          { label: 'Yes', value: 1 },
          { label: 'No',  value: 0 }
        ],
        extraQuestions: [
          {
            id: 'mdq_same_time',
            text: 'If you checked YES to more than one of the above, have several of these ever happened during the same period of time?',
            options: [
              { label: 'Yes', value: 1 },
              { label: 'No',  value: 0 }
            ]
          },
          {
            id: 'mdq_problem',
            text: 'How much of a problem did any of these cause you — like being unable to work; having family, money, or legal troubles; or getting into arguments or fights?',
            options: [
              { label: 'No problem',         value: 0 },
              { label: 'Minor problem',      value: 1 },
              { label: 'Moderate problem',   value: 2 },
              { label: 'Serious problem',    value: 3 }
            ]
          }
        ],
        score(answers, extra) {
          const yesCount = answers.slice(0, 13).reduce((s, v) => s + (v || 0), 0);
          const sameTime = (extra && extra.mdq_same_time) ? extra.mdq_same_time : 0;
          const problem  = (extra && extra.mdq_problem)   ? extra.mdq_problem   : 0;
          const positive = yesCount >= 7 && sameTime === 1 && problem >= 2;
          const level = positive ? 'Positive Screen — Possible Bipolar Disorder' : 'Screen Negative';
          const color = positive ? '#991b1b' : '#065f46';
          const bg    = positive ? '#fee2e2' : '#ecfdf5';
          return { total: yesCount, level, color, bg,
            text: `You endorsed ${yesCount} of 13 symptom items. Result: ${level}. This is a clinical screener — your provider will review results and discuss further at your appointment.` };
        }
      }
    };




  const DetailField = ({ label, value, width = "33.33%" }) => (
    <View style={{ width, marginBottom: 10 }}>
      <Text style={styles.fieldLabel}>{label}</Text>
      <Text style={styles.fieldValue}>{value || "-"}</Text>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
<View style={styles.headerWrapper}>

  {/* Logo with Clinic Text */}
  <View style={styles.logoImageRow}>
    {/* CODE's text letterhead for a CODE intake; C-HIM's logo for 9928;
        another practice's own logo (7825: OSA's) when its profile has one;
        otherwise the letterhead is text. */}
    {codeLetterhead ? (<>
      <Text style={styles.codeMark}>{brand.shortName}</Text>
      <Text style={styles.codeName}>{brand.name}</Text>
    </>) : practiceFeatures().chimContact ? (
      <Image src={logowithtext} style={styles.logoWithText} />
    ) : (
      practiceLogo(null) && <Image src={practiceLogo(null)} style={styles.logoWithText} />
    )}
  </View>

  {/* Doctor + Address Info */}
  <View style={styles.headerInfo}>
    {/* <Text style={styles.doctorNames}>
      Bobby Malik, MD | Madhu Pamganamamula, MD
    </Text> */}

    {/* CODE's address, phone and mailbox (no fax line) on a CODE intake;
        C-HIM's address and numbers: 9928 only (config/practice.js). */}
    {codeLetterhead ? (<>
    <Text style={styles.address}>{brand.contact.address}</Text>
    <Text style={styles.contact}>Ph: {brand.contact.phone}   {brand.contact.email}</Text>
    </>) : practiceFeatures().chimContact ? (<>
    <Text style={styles.address}>
   807 N Hancock Ave, Odessa, TX 79761
    </Text>

    <Text style={styles.contact}>
      Ph: 432-582-2446   Fax: 432-582-2960
    </Text>
    </>) : (<>
    {/* Another practice: its name (unless its logo shows it), then its
        own address and phone when the profile has them (7825). */}
    {!logoShowsName() && <Text style={styles.address}>{practiceName()}</Text>}
    {practiceContact().address ? <Text style={styles.address}>{practiceContact().address}</Text> : null}
    {practiceContact().phone ? <Text style={styles.contact}>Ph: {practiceContact().phone}</Text> : null}
    </>)}
  </View>

</View>

        {/* Patient Details */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>PATIENT DETAILS</Text>
<View style={styles.divider} />
          <View style={styles.detailsGrid}>
            <DetailField label="FIRST NAME1" value={forms.form_1?.firstname} />
            <DetailField label="LAST NAME" value={forms.form_1?.lastname} />
            <DetailField label="PHONE" value={forms.form_1?.phone} />
            <DetailField label="DATE OF BIRTH" value={forms.form_1?.dob} />
            <DetailField label="GENDER" value={forms.form_1?.gender} />
            <DetailField label="GENDER IDENTITY" value={forms.form_1?.genderIdentity} />
            <DetailField label="ADDRESS" value={forms.form_1?.address} width="66.66%" />
            <DetailField label="ZIP CODE" value={forms.form_1?.zipcode} />
            <DetailField label="MARITAL STATUS" value={forms.form_1?.maritalstatus} />
            <DetailField label="SSE" value={forms.form_1?.sse} />
            <DetailField label="HOME PHONE" value={forms.form_1?.homephone} />
            <DetailField label="SPOUSE NAME" value={forms.form_1?.spousename} />
            <DetailField label="SPOUSE PHONE" value={forms.form_1?.spousephone} />
            <DetailField label="SPOUSE HOME PHONE" value={forms.form_1?.spousehomephone} />
            <DetailField label="SPOUSE ADDRESS" value={forms.form_1?.spouseaddress} width="66.66%" />
            <DetailField label="SPOUSE ZIP CODE" value={forms.form_1?.spousezipcode} />
            <DetailField label="EMERGENCY CONTACT" value={forms.form_1?.emergencycontact} />
            <DetailField label="EMERGENCY PHONE" value={forms.form_1?.emergencyphone} />
            <DetailField label="RELATIONSHIP" value={forms.form_1?.relationship} />
            <DetailField label="REFERRED BY" value={forms.form_1?.referrredby} width="66.66%" />
          </View>

          {data?.profile && (
            <SafeImage
              stored={data.profile_url || data.profile}
              folder="profile_pics"
              fallback={`https://api.brainymed.com/chimlw/onboarding_forms/create/profile/${data.profile}`}
            />
          )}
        </View>

        {/* Insurance Details */}
        <View style={[styles.section, { break: 'before' }]}>
          <Text style={styles.sectionHeader}>INSURANCE DETAILS</Text>
          <View style={styles.divider} />
          <Text style={styles.subsectionTitle}>PRIMARY INSURANCE</Text>
          <View style={styles.detailsGrid}>
            <DetailField label="INSURANCE" value={forms.form_2?.primaryinsurancename || forms.form_2?.primaryinsurance}  />
            <DetailField label="POLICY NUMBER" value={forms.form_2?.primaryinsurance}  />
            <DetailField label="SUBSCRIBER" value={forms.form_2?.primarysubscribername} />
            <DetailField label="RELATIONSHIP" value={forms.form_2?.primaryrelationship} />
            <DetailField label="SUBSCRIBER ID" value={forms.form_2?.subscriberid} />
            <DetailField label="GROUP ID" value={forms.form_2?.groupid || forms.form_2?.primarygroupid} />
            <DetailField label="DOB" value={primaryDOB} />
            <DetailField label="WORKER COMP" value={forms.form_2?.workercompensation} />
            <DetailField label="AUTO ACCIDENT" value={forms.form_2?.autoaccident} />
            <DetailField label="SSN" value={forms.form_2?.primaryssn} />
          </View>

          {forms.form_2?.secondaryinsurancename && (
            <>
              <Text style={styles.subsectionTitle}>SECONDARY INSURANCE</Text>
              <View style={styles.detailsGrid}>
                <DetailField label="INSURANCE" value={forms.form_2?.secondaryinsurancename || forms.form_2?.secondaryinsurance}  />
                <DetailField label="POLICY NUMBER" value={forms.form_2?.secondaryinsurance}  />
                <DetailField label="SUBSCRIBER" value={forms.form_2?.secondarysubscribername} />
                <DetailField label="RELATIONSHIP" value={forms.form_2?.secondaryrelationship} />
                <DetailField label="SUBSCRIBER ID" value={forms.form_2?.secondarysubscriberid} />
                <DetailField label="GROUP ID" value={forms.form_2?.secondarygroupid} />
                <DetailField label="DOB" value={secondaryDOB} />
                <DetailField label="SSN" value={forms.form_2?.secondaryssn} />
              </View>
            </>
          )}

          {forms.form_2?.tertiaryinsurancename && (
            <>
              <Text style={styles.subsectionTitle}>TERTIARY INSURANCE</Text>
              <View style={styles.detailsGrid}>
                <DetailField label="INSURANCE" value={forms.form_2?.tertiaryinsurancename || forms.form_2?.tertiaryinsurance}/>
                <DetailField label="POLICY NUMBER" value={forms.form_2?.tertiaryinsurance} />
                <DetailField label="SUBSCRIBER" value={forms.form_2?.tertiarysubscribername}  />
                <DetailField label="RELATIONSHIP" value={forms.form_2?.tertiaryrelationship} />
                <DetailField label="SUBSCRIBER ID" value={forms.form_2?.tertiarysubscriberid} />
                <DetailField label="GROUP ID" value={forms.form_2?.tertiarygroupid} />
                <DetailField label="DOB" value={tertiaryDOB} />
                <DetailField label="SSN" value={forms.form_2?.tertiaryssn} />
              </View>
            </>
          )}

          {/* Insurance Images */}
          {data?.images
            ?.filter((img) => img.type === "INSURANCE" && (img.fornt_image || img.back_image_path))
            .map((img, idx) => (
              <View key={idx}>
                {img.fornt_image && (
                  <SafeImage
                    stored={img.front_url || img.fornt_image}
                    folder="images"
                    fallback={`https://api.brainymed.com/chimlw/onboarding_forms/uploadImages/images/${img.fornt_image}`}
                  />
                )}
                {img.back_image_path && (
                  <SafeImage
                    stored={img.back_url || img.back_image_path}
                    folder="images"
                    fallback={`https://api.brainymed.com/chimlw/onboarding_forms/uploadImages/images/${img.back_image_path}`}
                  />
                )}
              </View>
            ))}
        </View>

        {/* Present Health Concerns */}
        {normalizedForm3.healthConcerns?.length > 0 && (
          <View style={styles.section}>
            <Text style={styles.sectionHeader}>PRESENT HEALTH CONCERNS</Text>
            <Text style={styles.fieldValue}>
              {normalizedForm3.healthConcerns.map(capitalize).join(", ")}
            </Text>
          </View>
        )}

        {/* Personal Medical History */}
        <View style={[styles.section, { break: 'before' }]}>
          <Text style={styles.sectionHeader}>PERSONAL MEDICAL HISTORY</Text>
          <View style={styles.divider} />
          {forms.form_3?.medicalHistory?.length > 0 && (
            <Text style={styles.fieldValue}>
              {forms.form_3.medicalHistory.map(capitalize).join(", ")}
            </Text>
          )}
          
          {forms.form_3?.seriousConditions && (
            <View style={{ marginTop: 8 }}>
              {forms.form_3.seriousConditions.cancerYear && (
                <Text style={styles.fieldValue}>Cancer: {forms.form_3.seriousConditions.cancerYear}</Text>
              )}
              {forms.form_3.seriousConditions.heartAttackYear && (
                <Text style={styles.fieldValue}>Heart Attack: {forms.form_3.seriousConditions.heartAttackYear}</Text>
              )}
              {forms.form_3.seriousConditions.bloodTransfusionYear && (
                <Text style={styles.fieldValue}>Blood Transfusion: {forms.form_3.seriousConditions.bloodTransfusionYear}</Text>
              )}
              {forms.form_3.seriousConditions.strokeYear && (
                <Text style={styles.fieldValue}>Stroke: {forms.form_3.seriousConditions.strokeYear}</Text>
              )}
              {forms.form_3.seriousConditions.seizureYear && (
                <Text style={styles.fieldValue}>Seizure: {forms.form_3.seriousConditions.seizureYear}</Text>
              )}
            </View>
          )}

          {forms.form_3?.otherProblemDetails && (
            <View style={{ marginTop: 8 }}>
              <Text style={styles.fieldLabel}>OTHER PROBLEM DETAILS</Text>
              <Text style={styles.fieldValue}>{forms.form_3.otherProblemDetails}</Text>
            </View>
          )}
        </View>

        {/* Medications */}
        {forms.form_3?.medications?.length > 0 && (
          <View style={styles.section}>
            <Text style={styles.sectionHeader}>MEDICATIONS</Text>
            <View style={styles.divider} />
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderCell, styles.colMed]}>MEDICATION</Text>
                <Text style={[styles.tableHeaderCell, styles.colDose]}>DOSE (MG)</Text>
                <Text style={[styles.tableHeaderCell, styles.colTimes]}>TIMES/DAY</Text>
              </View>
              {forms.form_3.medications.map((med, idx) => (
                <View style={styles.tableRow} key={idx}>
                  <Text style={[styles.tableCell, styles.colMed]}>{med.medication}</Text>
                  <Text style={[styles.tableCell, styles.colDose]}>{med.dose}</Text>
                  <Text style={[styles.tableCell, styles.colTimes]}>{med.timesPerDay}</Text>
                </View>
              ))}
            </View>
          </View>
        )}

        {/* Allergies */}
        {forms.form_3?.allergies?.length > 0 && (
          <View style={styles.section}>
            <Text style={styles.sectionHeader}>ALLERGIES</Text>
            <View style={styles.divider} />
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderCell, styles.colAgent]}>AGENT</Text>
                <Text style={[styles.tableHeaderCell, styles.colReaction]}>REACTION</Text>
              </View>
              {forms.form_3.allergies.map((allergy, idx) => (
                <View style={styles.tableRow} key={idx}>
                  <Text style={[styles.tableCell, styles.colAgent]}>{allergy.agent}</Text>
                  <Text style={[styles.tableCell, styles.colReaction]}>{allergy.reaction}</Text>
                </View>
              ))}
            </View>
          </View>
        )}

        {/* Surgical History */}
        {forms.form_3?.surgicalHistory?.length > 0 ? (
          <View style={styles.section}>
            <Text style={styles.sectionHeader}>SURGICAL HISTORY</Text>
            <View style={styles.divider} />
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderCell, { width: "50%" }]}>OPERATION</Text>
                <Text style={[styles.tableHeaderCell, { width: "50%" }]}>DATE</Text>
              </View>
              {forms.form_3.surgicalHistory.map((surg, idx) => (
                <View style={styles.tableRow} key={idx}>
                  <Text style={[styles.tableCell, { width: "50%" }]}>{surg.operation}</Text>
                  <Text style={[styles.tableCell, { width: "50%" }]}>{surg.date}</Text>
                </View>
              ))}
            </View>
          </View>
        ) : (
          <View style={styles.section}>
            <Text style={styles.sectionHeader}>SURGICAL HISTORY</Text>
            <Text style={styles.fieldValue}>No surgical history reported</Text>
          </View>
        )}

        {/* Gynecologic History */}
        {normalizedForm3.gynecologicHistory && (
          <View style={styles.section}>
            <Text style={styles.sectionHeader}>GYNECOLOGIC HISTORY</Text>
            <View style={styles.divider} />
            <View style={styles.detailsGrid}>
              <DetailField label="PREGNANCIES" value={normalizedForm3.gynecologicHistory.pregnancies} />
              <DetailField label="DELIVERIES" value={normalizedForm3.gynecologicHistory.deliveries} />
              <DetailField label="ABORTIONS" value={normalizedForm3.gynecologicHistory.abortions} />
              <DetailField label="MISCARRIAGES" value={normalizedForm3.gynecologicHistory.miscarriages} />
              <DetailField label="LAST PERIOD DATE" value={normalizedForm3.gynecologicHistory.lastPeriodDate} />
              <DetailField label="AGE OF FIRST PERIOD" value={normalizedForm3.gynecologicHistory.ageOfFirstPeriod} />
              <DetailField label="PERIOD FREQUENCY" value={normalizedForm3.gynecologicHistory.periodFrequency} />
              <DetailField label="PERIOD LENGTH (DAYS)" value={normalizedForm3.gynecologicHistory.periodLength} />
              <DetailField 
                label="PERIOD CONCERNS" 
                value={capitalize(normalizedForm3.gynecologicHistory.periodConcerns)} 
                width="100%"
              />
              {normalizedForm3.gynecologicHistory.periodConcerns === "yes" && (
                <DetailField 
                  label="CONCERN DETAILS" 
                  value={normalizedForm3.gynecologicHistory.periodConcernsExplainText} 
                  width="100%"
                />
              )}
            </View>
          </View>
        )}

        {/* Medication Images */}
        {data?.images?.filter((img) => img.type === "MEDICATION" && img.fornt_image).length > 0 && (
          <View style={styles.section}>
            {data.images
              .filter((img) => img.type === "MEDICATION" && img.fornt_image)
              .map((img, idx) => (
                <SafeImage
                  key={idx}
                  stored={img.front_url || img.fornt_image}
                  folder="images"
                  fallback={`https://api.brainymed.com/chimlw/onboarding_forms/uploadImages/images/${img.fornt_image}`}
                />
              ))}
          </View>
        )}

        {/* Immunizations */}
        <View style={[styles.section, { break: 'before' }]}>
          <Text style={styles.sectionHeader}>IMMUNIZATIONS</Text>
          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <Text style={[styles.tableHeaderCell, { width: "50%" }]}>VACCINE</Text>
              <Text style={[styles.tableHeaderCell, { width: "50%" }]}>STATUS</Text>
            </View>
            {forms.form_8?.immunizations &&
              Object.entries(forms.form_8.immunizations)
                .filter(([key]) => key !== "otherVaccineDetails")
                .map(([vaccine, info], idx) => (
                  <View style={styles.tableRow} key={idx}>
                    <Text style={[styles.tableCell, { width: "50%" }]}>{prettifyKey(vaccine)}</Text>
                    <Text style={[styles.tableCell, { width: "50%" }]}>
                      {info.received ? "Yes" : "Not Received"}
                      {info.date ? ` - ${info.date}` : ""}
                    </Text>
                  </View>
                ))}
          </View>
          {forms.form_8?.immunizations?.otherVaccineDetails && (
            <Text style={styles.fieldValue}>Other: {forms.form_8.immunizations.otherVaccineDetails}</Text>
          )}
        </View>

        {/* Review of Symptoms */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>REVIEW OF SYMPTOMS</Text>
          <View style={styles.divider} />
          {forms.form_7?.reviewOfSystems && (
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderCell, { width: "30%" }]}>SYSTEM</Text>
                <Text style={[styles.tableHeaderCell, { width: "70%" }]}>STATUS</Text>
              </View>
              {Object.entries(forms.form_7.reviewOfSystems).map(([system, items]) =>
                items?.length > 0 ? (
                  <View style={styles.tableRow} key={system}>
                    <Text style={[styles.tableCell, { width: "30%" }]}>{prettifyKey(system)}</Text>
                    <Text style={[styles.tableCell, { width: "70%" }]}>
                      {items.map((item) =>
                        capitalize(
                          String(item)
                            .replace(/review\s+of\s+systems?\s*/gi, "")
                            .replace(/^ros\s*/i, "")
                            .replace(/([A-Z])/g, " $1")
                            .trim()
                        )
                      ).join(", ")}
                    </Text>
                  </View>
                ) : items?.length === 0 || (Array.isArray(items) && items.every(i => i === false)) ? (
                  <View style={styles.tableRow} key={system}>
                    <Text style={[styles.tableCell, { width: "30%" }]}>{prettifyKey(system)}</Text>
                    <Text style={[styles.tableCell, { width: "70%" }]}>Normal</Text>
                  </View>
                ) : null
              )}
            </View>
          )}
          {forms.form_7?.rosOther && (
            <View style={{ marginTop: 8 }}>
              <Text style={styles.fieldLabel}>OTHER</Text>
              <Text style={styles.fieldValue}>{forms.form_7.rosOther}</Text>
            </View>
          )}
        </View>

        {/* Social History */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>SOCIAL HISTORY</Text>
          <View style={styles.divider} />
          <View style={styles.detailsGrid}>
            <DetailField label="MARITAL STATUS" value={forms.form_5?.maritalStatus || forms.form_1?.maritalstatus} />
            <DetailField label="EDUCATION" value={forms.form_5?.education} />
            <DetailField label="TOBACCO USE" value={forms.form_5?.tobaccoUse} />
            <DetailField label="ALCOHOL USE" value={forms.form_5?.alcoholUse} />
            <DetailField label="ALCOHOL/WEEK" value={forms.form_5?.alcoholQuestions?.drinksPerWeek} />
            <DetailField label="ALCOHOL CONCERN" value={forms.form_5?.alcoholQuestions?.concernAboutDrinking} />
            <DetailField label="RECREATIONAL DRUGS" value={forms.form_5?.recreationalDrugs} />
            <DetailField label="NUMBER GENDER" value={forms.form_5?.sexualityQuestions?.numberOfGenderPartners} />
            <DetailField label="SEXUALLY ACTIVE" value={forms.form_5?.sexualActive} />
            <DetailField label="NUMBER OF CHILDREN" value={forms.form_5?.numberChildren} />
            <DetailField label="WHO LIVES WITH YOU" value={forms.form_5?.whoLiveWithYou} width="66.66%" />
            <DetailField label="OCCUPATION" value={forms.form_5?.occupation} width="100%" />
            <DetailField label="ETHNIC BACKGROUND" value={forms.form_5?.ethnicBackground} width="100%" />
          </View>

          {/* Tobacco Questions */}
          {forms.form_5?.tobaccoQuestions && (
            <View style={{ marginTop: 8 }}>
              {Object.entries(forms.form_5.tobaccoQuestions).map(([q, a]) => (
                <DetailField key={q} label={prettifyKey(q)} value={a} width="50%" />
              ))}
            </View>
          )}

          {/* Drug Questions */}
          {forms.form_5?.drugQuestions && (
            <View style={{ marginTop: 8 }}>
              {Object.entries(forms.form_5.drugQuestions).map(([q, a]) => (
                <DetailField key={q} label={prettifyKey(q)} value={a} width="50%" />
              ))}
            </View>
          )}

          {/* Mental Health Scores */}
          {(forms.form_5?.botheredByProblems != null || forms.form_5?.littlePleasure != null) && (
            <View style={{ marginTop: 8 }}>
              <DetailField label="BOTHERED BY PROBLEMS (0-5)" value={forms.form_5?.botheredByProblems} />
              <DetailField label="LITTLE PLEASURE (0-5)" value={forms.form_5?.littlePleasure} />
            </View>
          )}
        </View>

        {/* Family History */}
      <View style={styles.section}>
  <Text style={styles.sectionHeader}>FAMILY HISTORY</Text>
  <View style={styles.divider} />

  {forms.form_4?.noFamilyHistory ? (
    <Text style={styles.fieldValue}>Unknown Family History</Text>
  ) : forms.form_4?.familyHistory ? (
    <View style={styles.table}>

      <View style={styles.tableHeader}>
        <Text style={[styles.tableHeaderCell, { width: "50%" }]}>
          CONDITION
        </Text>
        <Text style={[styles.tableHeaderCell, { width: "50%" }]}>
          RELATIONSHIP
        </Text>
      </View>

      {Object.entries(forms.form_4.familyHistory)
        .filter(([key, value]) => value === true)
        .map(([key], index) => {

          const relationMap = {
            Mom: "Mother",
            Dad: "Father",
            Brother: "Brother",
            Sister: "Sister",
            GM: "Grandmother",
            GF: "Grandfather",
            Son: "Son",
            Daughter: "Daughter",
            Other: "Other"
          };

          const relationKey = Object.keys(relationMap).find(r => key.endsWith(r));
          const relationship = relationMap[relationKey] || "";

          const condition = key
            .replace(relationKey, "")
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, c => c.toUpperCase())
            .trim();

          return (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.tableCell, { width: "50%" }]}>
                {condition}
              </Text>
              <Text style={[styles.tableCell, { width: "50%" }]}>
                {relationship}
              </Text>
            </View>
          );
        })}

      {forms.form_4?.familyHistory?.otherFamilyHistory && (
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, { width: "50%" }]}>Other</Text>
          <Text style={[styles.tableCell, { width: "50%" }]}>
            {forms.form_4.familyHistory.otherFamilyHistory}
          </Text>
        </View>
      )}
    </View>
  ) : (
    <Text style={styles.fieldValue}>No family history provided</Text>
  )}
</View>

        {/* Care Team */}
        <View style={[styles.section, { break: 'before' }]}>
          <Text style={styles.sectionHeader}>CARE TEAM</Text>
          <View style={styles.divider} />
          {forms.form_6?.homeHealthCompany && (
            <DetailField label="HOME HEALTH COMPANY" value={forms.form_6.homeHealthCompany} width="100%" />
          )}
          {forms.form_6?.careTeam?.length > 0 && (
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderCell, styles.col1]}>SPECIALTY</Text>
                <Text style={[styles.tableHeaderCell, styles.col2]}>DOCTOR</Text>
                <Text style={[styles.tableHeaderCell, styles.col3]}>PHONE</Text>
              </View>
              {forms.form_6.careTeam.map((member, idx) => (
                <View style={styles.tableRow} key={idx}>
                  <Text style={[styles.tableCell, styles.col1]}>{member.specialty}</Text>
                  <Text style={[styles.tableCell, styles.col2]}>{member.doctorName}</Text>
                  <Text style={[styles.tableCell, styles.col3]}>{member.phone}</Text>
                </View>
              ))}
            </View>
          )}
        </View>

        {/* Consent Form */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>CONSENT FORM</Text>
          <View style={styles.divider} />
          {/* The wording the patient agreed to (intakeConsents): CODE's name
              on a CODE intake, C-HIM's otherwise. */}
          {forms.form_9 && intakeConsents(brand).map((consent) =>
            forms.form_9[consent.id] ? (
              <View key={consent.id} style={styles.consentItem}>
                <View style={styles.checkbox}>
                  <Text style={styles.checkmark}>✓</Text>
                </View>
                <Text style={styles.consentText}>{consent.label}</Text>
              </View>
            ) : null
          )}
        </View>
{/* Receipt of Notice of Privacy Policy */}







  {['phq9', 'stopbang', 'adhd', 'mdq'].map((key) => {
    const formData = forms[key];
    if (!formData) return null;

    // Build a list of question + answer pairs
    const qaList = [];

    // Regular questions
    QUESTIONNAIRES[key].questions.forEach((q, idx) => {
      const answerKey = `qanswer_${key}_${idx + 1}`;
      const answer = formData[answerKey];
      if (answer !== undefined && answer !== null && answer !== "") {
        qaList.push({ text: `${q} — ${answer}` });
      }
    });

    // PHQ-9 extra question
    if (key === 'phq9' && formData['qanswer_phq9_10']) {
      qaList.push({
        text: `${QUESTIONNAIRES.phq9.extraQuestion.text} — ${formData['qanswer_phq9_10']}`
      });
    }

    // MDQ extra questions
    if (key === 'mdq') {
      QUESTIONNAIRES.mdq.extraQuestions.forEach((extraQ) => {
        const answer = formData[extraQ.id];
        if (answer !== undefined && answer !== null && answer !== "") {
          qaList.push({ text: `${extraQ.text} — ${answer}` });
        }
      });
    }

    return (
      <View key={key} style={styles.section}>
        <Text style={styles.sectionHeader}>{QUESTIONNAIRES[key].title}</Text>
        <View style={styles.divider} />

        {qaList.map((item, idx) => (
          <View key={idx} style={styles.consentItem}>
            <Text style={styles.bulletText}>•</Text>
            <Text style={styles.consentText}>{item.text}</Text>
          </View>
        ))}
      </View>
    );
  })}







  <View style={styles.section}>
    <Text style={styles.sectionHeader}>
      RECEIPT OF NOTICE OF PRIVACY POLICY
    </Text>
    <View style={styles.divider} />

    <View style={styles.receiptContainer}>
      <Text style={styles.fieldLabel}>DATE ACKNOWLEDGED</Text>
    <Text style={styles.fieldValue}>
  {forms.created_at ? dayjs(forms.created_at).format("MM-DD-YYYY") : "-"}
</Text>
    </View>

  <View style={styles.signatureRow}>
  <View style={styles.signatureBox}>
    <View style={styles.signatureLine} />
    <Text style={styles.signatureLabel}>PATIENT SIGNATURE</Text>
  </View>

  <View style={styles.dateBox}>
    <View style={styles.signatureLine} />
    <Text style={styles.signatureLabel}>DATE</Text>
  </View>
</View>
  </View>


        {/* Uploaded Document */}
        {data?.document_file && (
          <View style={styles.section}>
            <Text style={styles.sectionHeader}>UPLOADED DOCUMENT</Text>
            <Text style={styles.fieldValue}>{data.document_file}</Text>
          </View>
        )}

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text>{codeLetterhead ? `${brand.name} (${brand.legalName}) — Confidential` : "Center for Hypertension Services — Confidential"}</Text>
          <Text>{forms.form_1?.firstname} {forms.form_1?.lastname} | ID: {forms.id}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default OnboardPDF;